import { Injectable, SecurityContext } from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SanitizeService {
  constructor(private sanitizer: DomSanitizer) {}

  public sanitizeString(stringToSanitize: string): SafeHtml {
    if (!stringToSanitize || stringToSanitize.length === 0 || stringToSanitize === undefined) {
      return '';
    }

    //const stringWithTags = stringToSanitize.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
    //return this.sanitizer.bypassSecurityTrustHtml(stringWithTags);

    const stringWithTags = stringToSanitize.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
    return this.sanitizer.bypassSecurityTrustHtml(stringWithTags);
  }

  sanitizeLegals(value) {
    const stringWithTags = value.replace(/&lt;/gi, '<').replace(/&gt;/gi, '>');
    return this.sanitizer.bypassSecurityTrustHtml(stringWithTags);
  }

  sanitizeUrl(value) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
}
